import styled, { css, keyframes } from 'styled-components';
const pulse = keyframes(["0%{opacity:1;}50%{opacity:0.75;}100%{opacity:0;transform:scale(3);}"]);
const pulseAnimation = css(["animation:", " 2s ease-out infinite;"], pulse);
export const StyledGreenFilledCircle = styled.div.withConfig({
  displayName: "CallIconstyles__StyledGreenFilledCircle",
  componentId: "dupax9-0"
})(["width:8px;height:8px;position:absolute;top:-2px;right:-2px;border-radius:100%;background-color:", ";"], ({
  theme
}) => theme.color['fill-positive-default']);
export const StyledEmptyCircle = styled.div.withConfig({
  displayName: "CallIconstyles__StyledEmptyCircle",
  componentId: "dupax9-1"
})(["width:8px;height:8px;position:absolute;top:-2px;right:-2px;border-radius:100%;background-color:transparent;border:0.25px solid ", " !important;"], ({
  color
}) => color);
export const StyledActiveCallPulsingAnim = styled.span.withConfig({
  displayName: "CallIconstyles__StyledActiveCallPulsingAnim",
  componentId: "dupax9-2"
})(["width:100%;height:100%;position:absolute;right:0;border-radius:100%;background-color:", ";opacity:0.8;", ";"], ({
  theme
}) => theme.color['fill-positive-default'], pulseAnimation);
export const StyledErrorContainer = styled.div.withConfig({
  displayName: "CallIconstyles__StyledErrorContainer",
  componentId: "dupax9-3"
})(["position:absolute;width:14px;height:14px;border-radius:100%;background-color:", " !important;top:-7px;right:-7px;::after{content:'!';position:absolute;top:50%;left:50%;color:", ";font-size:11px;font-weight:400;transform:translate(-50%,-50%);}"], ({
  theme
}) => theme.color['fill-alert-pressed'], ({
  theme
}) => theme.color['text-alert-on-fill-default']);
export const CallIconWithStatus = styled.div.withConfig({
  displayName: "CallIconstyles__CallIconWithStatus",
  componentId: "dupax9-4"
})(["background:transparent;border-radius:6px;border-style:none;position:relative;width:", ";height:", ";"], ({
  width
}) => width, ({
  height
}) => height);